import { render, staticRenderFns } from "./m-history-list.vue?vue&type=template&id=a3c3be4e&"
import script from "./m-history-list.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-history-list.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-history-list.vue?vue&type=style&index=0&id=a3c3be4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports